import { SET_VIDEOS_DATA, SET_POPUP_VIDEO_ID, RESET_POPUP_VIDEO_ID } from 'js/store/videos/Videos.actions.js';

import { parseData } from 'js/store/videos/Videos.parser.js';

const initState = {
  videoIds: [],
  videosById: {},
  popupVideoId: false,
};

const videos = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case SET_VIDEOS_DATA: {
      const { videosById, videoIds } = parseData(action.payload);
      nextState.videoIds = videoIds;
      nextState.videosById = videosById;
      return { ...state, ...nextState };
    }
    case SET_POPUP_VIDEO_ID: {
      nextState.popupVideoId = action.payload;
      return { ...state, ...nextState };
    }
    case RESET_POPUP_VIDEO_ID: {
      nextState.popupVideoId = false;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default videos;
